import React, { forwardRef, useState, useEffect } from 'react';
import DatePickerReact, { ReactDatePickerProps } from 'react-datepicker';
import { CalendarBlank } from 'phosphor-react';
import { ptBR } from 'date-fns/locale';
import { addDays } from 'date-fns';

import 'react-datepicker/dist/react-datepicker.css';

import { DatePickerContainer, DatePickerStyle } from './styles';

type ButtonProps = React.HTMLProps<HTMLButtonElement>;
export type DatePickerMonthRangeProps = ReactDatePickerProps;

interface DateRangeState {
  startDate: Date;
  endDate: Date;
}

interface ButtonPropsI extends ReactDatePickerProps {
  setDateRange?: (payload: DateRangeState) => void;
  disabled?: boolean;
  defaultStartDate?: Date;
  defaultEndDate?: Date;
  shouldCloseOnSelect?: boolean;
}

export const DatePickerMonthRange: React.FC<ButtonPropsI> = ({
  setDateRange = () => {},
  disabled = false,
  defaultStartDate,
  defaultEndDate,
  shouldCloseOnSelect = false,
  ...props
}) => {
  const [start, setStart] = useState<Date | null>(
    defaultStartDate ? defaultStartDate : new Date(),
  );
  const [end, setEnd] = useState<Date | null>(
    defaultEndDate ? defaultEndDate : new Date(),
  );

  const onChange = (dates: [Date | null, Date | null]) => {
    const [selectedStart, selectedEnd] = dates;

    setStart(selectedStart);
    setEnd(selectedEnd);
  };

  useEffect(() => {
    if (end && start) {
      setDateRange({ startDate: start, endDate: end });
    }
  }, [end, start, setDateRange]);

  const DatePickerCustomInput = forwardRef<HTMLButtonElement, ButtonProps>(
    ({ value, onClick }, ref) => {
      return (
        <DatePickerContainer
          className="datepicker-custom-input"
          onClick={onClick}
          ref={ref}
          type="button"
          disabled={disabled}
        >
          <span className={`${value === '' && 'color-gray-70'}`}>
            {value === '' ? 'dd/mm/aaaa hh:mm' : value}
          </span>
          <div className="calendar">
            <CalendarBlank />
          </div>
        </DatePickerContainer>
      );
    },
  );

  return (
    <DatePickerStyle>
      <DatePickerReact
        {...props}
        dateFormat="MMMM/yyyy"
        selectsRange={true}
        selected={start}
        onChange={(value) => onChange(value)}
        startDate={start}
        endDate={end}
        showMonthYearPicker
        customInput={<DatePickerCustomInput />}
        locale={ptBR}
        disabled={disabled}
        maxDate={addDays(new Date(), 0)}
      />
    </DatePickerStyle>
  );
};

// export const DatePickerMonthRange: React.FC<DatePickerMonthRangeProps> = ({ ...props }) => {
//   return (
//     <DatePickerStyle>
//       <DatePickerReact
//         selected={selectedDate}
//         dateFormat="MMMM/yyyy"
//         locale={ptBR}
//         showMonthYearPicker
//         selectsRange={true}
//         customInput={<DatePickerCustomInput />}
//         {...props}
//         maxDate={new Date()}
//         onChange={(value) => onChange(value)}
//       />
//     </DatePickerStyle>
//   );
// };
